// @ts-nocheck

// This file is for functions that I don't want to check but live in the global public js
export function showToastWrapper(msg, isError) {
  showToast(msg, isError)
}

export const SOUND_FROM_DRAWER_PREFIX = "sound-from-drawer-";
export const SCENE_FROM_DRAWER_PREFIX = "scene-from-drawer-";
export const MAX_SOUND_NAME_LENGTH = 32;
export const MOBILE_SCREEN_WIDTH = 700;

export function fetchAttribution(soundId, callback) {
  fetch(`/api/public/attribution/${soundId}`)
    .then((response) => response.json())
    .then((data) => callback(data)) // Might be null if there is no attribution
    .catch((err) => {
      showToastWrapper("Error getting attribution for sound: " + err);
    });
}
export async function fetchAttributionAsync(soundId) {
  return await fetch(`/api/public/attribution/${soundId}`)
    .then((response) => response.json())
    .catch((err) => {
      showToastWrapper("Error getting attribution for sound: " + err);
    });
}

export function moveElementInArray(arr, from, to) {
  const item = arr.splice(from, 1)[0]
  arr.splice(to, 0, item);
}

export function unlinkSound(soundId, soundBoard) {
    if (!soundBoard.ContainsSound(soundId)) {
      // TODO BL: Error management, probably we'll have to move this isnide the DeleteCard update method.
      fetch(`/app/soundboard/sound/unlink/${soundId}`, {
        method: "DELETE",
      });
    }
}

export function isFocusedScene(scene) {
  return window.location.href.startsWith(scene.Permalink());
}

// This is duplicated from layout.js, but svelte needs a way to initialize the isDarkTheme writable.
export function readDarkThemeFromLocalStorage() {
  let theme = localStorage.getItem("data-theme")
  if (theme === undefined || theme === "") {
    theme = "light"
  }
  return theme === "dark";
}; 

function capturePosthog(eventToCapture) {
  posthog.capture(eventToCapture);
}